<template>
    <div id="tableA" class="p-3 rounded bSecondary shadow-def">
        <p class="lead" v-bind:class=lead >{{title}}</p>
        <table>
            <tr class="tSecondary brdr-bot borPrimary" v-for="(d, i) in data" :key="i">
                <td class="" v-if="d.id">{{d.id}}</td>
                <td class="" v-if="d.name">{{d.name}}</td>
                <td class="" v-if="d.ip">{{d.ip}}</td>
                <td class="" v-if="d.lts">{{d.lts}}</td>
                <td class="" v-if="d.city">{{d.city}}</td>
                <td class="" v-if="d.post">{{d.post}}</td>
                <td class="">{{d.lastVisited}}</td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
    name:"tableA",
    props:{
        data:Array,
        title:String,
        lead:String
    }
}
</script>

<style lang='scss'>
#tableA{
    table{
        width: 100%;
        td{padding: 0.3rem 0.5rem}
    }
}
</style>
